import httpAxiosApi from "../core/axios.errors.handle";
import { useRequest } from 'vue-request'

export const fetchCurrentUserCategory = () => {
    return httpAxiosApi.get('/webapi/profile/whoami/category').then(
        (response) => {
            return {...response.data};
        })
}

export const useCurrentUserCategory = (options = {}) => {
    return useRequest(fetchCurrentUserCategory, {
        cacheKey: () => '/webapi/profile/whoami/category',
        ...options,
    })
}

export const fetchCategories = () => {
    return httpAxiosApi.get('/webapi/auth/reg/categories').then(
        (response) => {
            return [...response.data.categories];
        });
}

export const useCategories = (options = {}) => {
    return useRequest(fetchCategories, {
        cacheKey: () => '/webapi/auth/reg/categories',
        ...options,
    })
}